/**
 * Created by mykurisu on 2017/8/8.
 */
import React from 'react'
import {connect} from 'react-redux'
import CurrencyItem from '../search/CurrencyItem'
import {WKCurrencyItem} from '../../components/wk'
import '../../styles/search/SearchPage.css'

class SearchChannel extends React.Component {

    render() {
        const {search} = this.props;
        let list = search.channel_list.length > 0 && search.channel_list.slice(0,3);
        return (
            <div className="search-page-channel">
                {list.map((item) => <WKCurrencyItem content={item} key={item.id} type={"channel"}/>)}
            </div>
        )
    }
}

export default connect(state => ({
    search: state.search
}))(SearchChannel)


// WEBPACK FOOTER //
// ./src/components/search/SearchChannel.js